import React, { PropsWithChildren } from "react";
import { Col, Container, Row } from "reactstrap";

export class CenterLayout extends React.Component<PropsWithChildren> {
  componentDidMount() {
    this.updateHeading();
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  componentDidUpdate() {
    this.updateHeading();
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  updateHeading = () => {
    setTimeout(() => {
      const heading = document.querySelector(".jumbotron h1") as HTMLElement;

      if (heading && heading.textContent === "Anmeldung") {
        heading.textContent = "WILLKOMMEN BEI MARC O'POLO MEMBERS";
      }

      // Modify login layout for marcopolo theme
      this.modifyLoginLayout();
    }, 100);
  };

  modifyLoginLayout = () => {
    const submitButton = document.querySelector('button[type="submit"]') as HTMLButtonElement;
    const forgotPasswordLink = document.querySelector('a[href="/forgot-password"]') as HTMLAnchorElement;
    const jumbotronElement = document.querySelector(".jumbotron");
    const registrationRow = jumbotronElement?.nextElementSibling as HTMLElement;

    if (submitButton) {
      // Change button text
      submitButton.textContent = "EINLOGGEN";
      submitButton.className = "btn btn-secondary w-100 mt-3";
    }

    // Handle forgot password link separately
    if (forgotPasswordLink) {
      forgotPasswordLink.style.display = "block";
      forgotPasswordLink.style.textAlign = "left";
      //forgotPasswordLink.style.marginBottom = "5px";

      if (submitButton) {
        const buttonContainer = submitButton.parentElement;
        if (buttonContainer) {
          buttonContainer.insertBefore(forgotPasswordLink, submitButton);
        }
      }
    }

    if (registrationRow) {
      // Create new registration section
      const newRegistrationDiv = document.createElement("div");
      newRegistrationDiv.className = "mt-4 text-center";
      newRegistrationDiv.innerHTML = `
        <p class="login-registration-prompt login-divider-text">Sie haben noch kein Kundenkonto?</p>
        <button class="btn w-100 login-register-button" onclick="window.location.href='/register'">JETZT REGISTRIEREN</button>
      `;

      // Replace old registration row
      const jumbotron = document.querySelector(".jumbotron");
      if (jumbotron) {
        jumbotron.appendChild(newRegistrationDiv);
        registrationRow.style.display = "none";
      }
    }
  };

  render() {
    return (
      <div className="login-layout">
        <div className="login-header">
          <img src={require("../images/favicon.ico")} alt="Marc O'Polo" className="login-favicon" />
          <div className="login-divider"></div>
        </div>
        <Container fluid className="login-container">
          <Row className="login-row">
            <Col md={6} className="login-image-col">
              <img
                src={require("../images/fw25_casual08_women_marc-o-polo_gisele_hero.jpg")}
                alt="Marc O'Polo Fashion"
                className="login-hero-image"
              />
            </Col>
            <Col md={6} className="login-form-col">
              <div className="login-form-container">{this.props.children}</div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
